import { render, staticRenderFns } from "./QuestionnairesGrid.vue?vue&type=template&id=0742e5b8"
import script from "./QuestionnairesGrid.vue?vue&type=script&lang=js"
export * from "./QuestionnairesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports